<template>
    <div>
        <form class="content-box bg-white-like mb-5 pb-5 lh-sm create-address" @submit.prevent="submitEdit" id="editProfileForm">
            <div v-show="success" class="row mb-4 align-items-center">
                <div class="mt-3 alert alert-success fade show pb-0">
                    <p class="pb-0">Votre profil a bien été mis à jour !</p>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0" for="profile-gender">Vous êtes :</label>
                <div class="col-12 col-md-8 px-md-0 px-0 position-relative select-wrapper">
                    <select name="profile-gender" id="profile-gender" class="form-input px-2 form-input-select w-100 classic" v-model="profile_data.gender">
                        <option value=""></option>
                        <option :value="'f'">Une femme</option>
                        <option :value="'m'">Un homme</option>
                    </select>

                    <div v-if="errors.gender" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.gender" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0" for="profile-last_name">Votre nom
                    <span class="description-tooltip-icon btn px-1 py-0 fw-bold fs-5 lh-sm tooltip-container tooltipTrigger" id="tooltipTrigger110">
                        ?
                        <span id="tooltip110" class="tooltip-box tooltip-box-position black fw-normal text-center hide">Ne sera pas affiché sur le site</span>
                    </span>
                    * :
                </label>

                <div class="col-12 col-md-8 px-md-0 px-0">
                    <input class="form-input px-2 form-input-text" id="profile-last_name" type="text" v-model="profile_data.last_name">
                    <div v-if="errors.last_name" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.last_name" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0" for="profile-first_name">Votre prénom
                    <span class="description-tooltip-icon btn px-1 py-0 fw-bold fs-5 lh-sm tooltip-container tooltipTrigger" id="tooltipTrigger120">
                        ?
                        <span id="tooltip120" class="tooltip-box tooltip-box-position black fw-normal text-center hide">Ne sera pas affiché sur le site</span>
                    </span>
                    * :
                </label>

                <div class="col-12 col-md-8 px-md-0 px-0">
                    <input class="form-input px-2 form-input-text" id="profile-first_name" type="text" v-model="profile_data.first_name">
                    <div v-if="errors.first_name" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.first_name" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center ">
                <label class="fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0" for="profile-address">Votre N° et rue :</label>
                <div class="col-12 col-md-8 px-md-0 px-0">
                    <input class="form-input px-2 form-input-text " id="profile-address" type="text" v-model="profile_data.address">
                    <div v-if="errors.address" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.address" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0" for="profile-city">Ville* :</label>
                <div class="position-relative d-inline-block col-12 col-md-8 px-md-0 px-0">
                    <input class="form-input px-2 form-input-text" autocomplete="off" id="profile-city" type="text" v-model="profile_data.city.name" @keyup="getCity()">
                    <ul v-show="citiesSuggestionsList" class="list-unstyled position-absolute cities-suggestions-list">
                        <li v-for="item of this.citiesSuggestionsList" class="m-1" @click="setCity(item.id, item.name, item.postal_code)">{{ item.name + ' ' + item.postal_code }}</li>
                    </ul>
                    <div v-if="errors.city_id" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.city_id" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center checkbox-wrapper">
                <label class="form-check-label fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0" for="profile-hide-city">
                    Masquer ma ville sur mon profil :
                </label>

                <div class="col-12 col-md-8 px-md-0 px-3">
                    <input class="form-check-input" type="checkbox" id="profile-hide-city" v-model="profile_data.city_show">
                    <div v-if="errors.city_show" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.city_show" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <label class="fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0" for="profile-birthday">Date de naissance :</label>
                <div class="col-12 col-md-8 px-md-0 position-relative px-0">
                    <input type="date" class="form-input px-2 form-input-text" name="profile-birthday" id="profile-birthday" v-model="profile_data.birthday">

                    <div v-if="errors.birthday" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.birthday" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <div class="col-12 col-md-4 mb-2 mb-md-0">
                    <label class="fw-bold fs-5" for="profile-presentation">Présentation :</label>
                    <p class="fw-bold fs-5 mb-0" v-model="characters">{{ characters }} {{ characters >= 2 ? 'caractères restants' : 'caractère restant' }}
                        <span class="description-tooltip-icon btn px-1 py-0 fw-bold fs-5 lh-sm tooltip-container tooltipTrigger" id="tooltipTrigger130">
                            ?
                            <span id="tooltip130" class="tooltip-box tooltip-box-position black fw-normal text-center hide">Présentez-vous en quelques lignes et faites découvrir à la communauté quel justacotin de qualité vous êtes !</span>
                        </span>
                    </p>
                </div>
                <div class="col-12 col-md-8 position-relative px-0">
                    <textarea type="date" class="form-input px-2 form-input-text" name="profile-presentation" id="profile-presentation" v-model="profile_data.presentation" @keyup="countCharacters"></textarea>

                    <div v-if="errors.presentation" class="bg-darkRed text-white mb-3 mt-2 p-2">
                        <p v-for="error of this.errors.presentation" class="lh-sm mb-0">{{ error }}</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4 align-items-center">
                <p class="fw-bold fs-5 col-12 col-md-4 mb-2 mb-md-0">Centres d'intérêts
                    <span class="description-tooltip-icon btn px-1 py-0 fw-bold fs-5 lh-sm tooltip-container tooltipTrigger" id="tooltipTrigger140">
                        ?
                        <span id="tooltip140" class="tooltip-box tooltip-box-position black fw-normal text-center hide">Partagez ce que vous aimez faire dans la vie en renseignant vos hobbies. 1 case = 1 passion</span>
                    </span>
                </p>
                <div class="col-12 col-md-8">
                    <div class="row gy-2 justify-content-between interests pe-2">
                        <input class="col-6 col-md-4 form-input px-2 form-input-text" id="profile-interest1" type="text" v-model="profile_data.interests.interest1">
                        <input class="col-6 col-md-4 form-input px-2 form-input-text" id="profile-interest2" type="text" v-model="profile_data.interests.interest2">
                        <input class="col-6 col-md-4 form-input px-2 form-input-text" id="profile-interest3" type="text" v-model="profile_data.interests.interest3">
                        <input class="col-6 col-md-4 form-input px-2 form-input-text" id="profile-interest4" type="text" v-model="profile_data.interests.interest4">
                        <input class="col-6 col-md-4 form-input px-2 form-input-text" id="profile-interest5" type="text" v-model="profile_data.interests.interest5">
                        <input class="col-6 col-md-4 form-input px-2 form-input-text" id="profile-interest6" type="text" v-model="profile_data.interests.interest6">
                    </div>
                </div>
            </div>

            <a :href="user_link" class="btn btn-red ps-2 pe-5" type="submit"><i class="fas fa-caret-left text-white ms-2 me-4"></i>Annuler</a>
            <button class="btn btn-red ps-5 pe-3" type="submit">Valider<i class="fas fa-caret-right text-white ms-4"></i></button>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        user_data: Object,
        user_city: Object,
        user_interests: Array,
        user_link: String
    },

    components: {},

    data() {
        return {
            success: false,
            ajaxReq: '',
            citiesSuggestionsList: null,
            characters: 200,
            errors: {
                address: null,
                birthday: null,
                city_id: null,
                first_name: null,
                gender: null,
                last_name: null,
                presentation: null,
            },
            profile_data: {
                id: null,
                city: {
                    id: null,
                    name: null,
                    postcode: null,
                },
                last_name: null,
                first_name: null,
                address: null,
                city_show: false,
                gender: '',
                birthday: '',
                presentation: null,
                interests: {
                    interest1: null,
                    interest2: null,
                    interest3: null,
                    interest4: null,
                    interest5: null,
                    interest6: null,
                }
            },
        }
    },

    mounted() {
        this.profile_data.last_name = this.user_data.last_name;
        this.profile_data.first_name = this.user_data.first_name;
        this.profile_data.address = this.user_data.address;
        this.profile_data.gender = this.user_data.civility;
        this.profile_data.city_show = this.user_data.city_show;
        this.profile_data.birthday = this.user_data.birthday;
        this.profile_data.presentation = this.user_data.description;
        this.profile_data.id = this.user_data.id
        this.countCharacters();

        if (this.user_city) {
            this.profile_data.city.id = this.user_city.id
            this.profile_data.city.name = this.user_city.name
            this.profile_data.city.postcode = this.user_city.postal_code
        }

        if (this.user_interests.length > 0) {
            for (const interest of Object.entries(this.user_interests)) {
                this.profile_data.interests[`interest${parseInt(interest[0]) + 1}`] = interest[1].name
            }
        }
    },

    methods: {
        countCharacters() {
            let presentationLength = this.profile_data.presentation ? this.profile_data.presentation.length : 0;
            this.characters = 200 - presentationLength

            if (presentationLength > 200) {
                this.profile_data.presentation = this.profile_data.presentation.substring(0, 198)
            }
        },

        async getCity() {
            if (this.profile_data.city.name.length > 1) {
                if (this.ajaxReq) {
                    this.ajaxReq.cancel('stop');
                }

                this.ajaxReq = axios.CancelToken.source();

                await axios.get(`/api/v1/cities/${this.profile_data.city.name}`, {
                    cancelToken: this.ajaxReq.token,
                }).then((response) => {
                    this.citiesSuggestionsList = response.data
                }).catch((error) => {
                    if (axios.isCancel(error)) {
                        return "axios request cancelled";
                    }

                    return error;
                })
            }

            if (this.profile_data.city.id !== null) {
                this.profile_data.city.id = null;
                this.profile_data.city.name = null;
                this.profile_data.city.postcode = null;
            }
        },

        setCity(cityId, cityName, cityPostcode) {
            this.profile_data.city.id = cityId;
            this.profile_data.city.name = cityName;
            this.profile_data.city.postcode = cityPostcode;
            this.citiesSuggestionsList = null;
            // this.checkAddress()
        },

        submitEdit() {
            // this.errors = {};

            if(! this.profile_data.city.id) {
                this.errors['city_id'] = ['Votre ville est obligatoire'];
            } else {
                axios.post(`/users/edit`, this.profile_data)
                    .then((response) => {
                        this.success = response.data;
                        this.errors = {};

                        setTimeout(() => {
                            window.location.href = 'edit';
                        }, 2000);
                    })
                    .catch((error) => {
                        let errors = error.response.data.errors
                        for (const [error_item_key, error_item] of Object.entries(errors)) {
                            this.errors[error_item_key] = error_item;
                        }
                    })
            }
        },
    }
};
</script>
